module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fontS14 container mx-3"
  }, [_c('h3', {
    staticClass: "bold"
  }, [_vm._v("¡Gracias por comprar en " + _vm._s(_vm.companyName) + "!")]), _vm._v(" "), _c('p', [_vm._v("Te enviaremos un correo electrónico y mensaje de texto cuando tu pedido esté en camino.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4"
  }, [_vm._v("Recuerda que si no podrás estar presente, deberás dejar a un tercero con el monto exacto a pagar.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb2c03b6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/storePickUp.vue
// module id = 1163
// module chunks = 45